import React from "react";

function DocumentSVG({ colorCode }) {
  return (
    <svg
      className={`MuiSvgIcon-root`}
      viewBox="0 0 24 29"
      style={{ fill: "none" }}
    >
      <path
        d="M14.25 1H3.65C2.94717 1 2.27314 1.2792 1.77617 1.77617C1.2792 2.27314 1 2.94717 1 3.65V24.85C1 25.5528 1.2792 26.2268 1.77617 26.7238C2.27314 27.2208 2.94717 27.5 3.65 27.5H19.55C20.2528 27.5 20.9268 27.2208 21.4238 26.7238C21.9208 26.2268 22.2 25.5528 22.2 24.85V8.94999L14.25 1Z"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 1V8.94999H22.2"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8998 15.5752H6.2998"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8998 20.8749H6.2998"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9498 10.2749H7.6248H6.2998"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DocumentSVG;
